import React, { Component } from 'react'

type Props = {
  finishedBooksCount: number
  promisedBooksCount: number
}

export class ReadingProgressBarDefault extends Component<Props> {
  render(): JSX.Element {
    const { finishedBooksCount, promisedBooksCount } = this.props

    let progressBarWidth
    let progressBarClassName = 'reading-progress-bar__progress-bar'
    const promiseFulfilledModifier = '_promise-fulfilled'
    const setStylesForFulfilledPromise = () => {
      progressBarWidth = 100
      progressBarClassName = `${progressBarClassName} ${progressBarClassName}${promiseFulfilledModifier}`
    }
    const setStylesForUnfulfilledPromise = () => {
      progressBarWidth = (finishedBooksCount / promisedBooksCount) * 100
    }

    if (
      promisedBooksCount === 0 ||
      finishedBooksCount / promisedBooksCount >= 1
    ) {
      setStylesForFulfilledPromise()
    } else {
      setStylesForUnfulfilledPromise()
    }

    return (
      <div className="reading-progress-bar__progress-bar-container">
        <div className="reading-progress-bar__progress-bar-background"></div>
        <div
          className={progressBarClassName}
          style={{ width: `${progressBarWidth}%` }}
        ></div>
      </div>
    )
  }
}
